import { render, staticRenderFns } from "./PlmnTable.vue?vue&type=template&id=0412ec91&scoped=true&"
import script from "./PlmnTable.vue?vue&type=script&lang=js&"
export * from "./PlmnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412ec91",
  null
  
)

export default component.exports